import React from 'react'
import { createRoot } from 'react-dom/client'
import DeleteModal from '../components/DeleteModal'

const container = document.getElementById('delete-modal-root')
if (container) createRoot(container).render(<DeleteModal />)
